/* global elementorFrontend */
import $ from 'jquery';

export const sliderLoopCarousel = () => {
	const enableAutoHeight = function ($element) {
		const $swiperEl = $element.find('.swiper');
		if (!$swiperEl.length) return;

		const applyAutoHeight = function () {
			const container = $swiperEl[0];
			if (!container) return;
			const swiper = container.swiper || $swiperEl.data('swiper');

			if (swiper) {
				const isMobileTablet = window.innerWidth <= 1024;
				swiper.params.autoHeight = isMobileTablet;
				swiper.update();

				if (!swiper._autoHeightBound) {
					swiper._autoHeightBound = true;
					swiper.on('slideChange', function () {
						if (window.innerWidth <= 1024 && swiper.updateAutoHeight) {
							setTimeout(function () {
								swiper.updateAutoHeight(300);
							}, 50);
						}
					});
				}
			}
		};

		applyAutoHeight();
		setTimeout(applyAutoHeight, 200);
		setTimeout(applyAutoHeight, 600);
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction('frontend/element_ready/loop-carousel.post', enableAutoHeight);
			elementorFrontend.hooks.addAction('frontend/element_ready/loop-carousel.default', enableAutoHeight);
		}
	});

	$('.mi-carousel.elementor-widget-loop-carousel, .elementor-widget-loop-carousel').each(function () {
		enableAutoHeight($(this));
	});
};

try {
	sliderLoopCarousel();
} catch (error) {
	console.warn(error);
}
